import {
  Button,
  Modal,
  Result,
} from "antd";
import React from "react";
import "./style.css";
import { MdOutlineAutoDelete } from "react-icons/md";

const ModalDeleteCVInterview = ({
 isModalDelCVInterview,
 setIsModalDelCVInterview,
 onFinishDeleteMeeting
}) => {

  return (
    <Modal
      open={isModalDelCVInterview}
      onCancel={() => setIsModalDelCVInterview(false)}
      footer={false}
      // onOk={onFinish}
      // title={"Xác nhận xóa lịch làm việc của team"}
      width={700}
      className={"timekeeper-error-modal"}
    >
      <Result
        status="error"
        title={"Xác nhận xóa các CV khỏi lịch phỏng vấn."}
        icon={
          <MdOutlineAutoDelete style={{ color: "#ff4d4f", fontSize: "60px" }} />
        }
        extra={
          <Button type="primary" danger key="Xóa" onClick={onFinishDeleteMeeting}>
            XÓA
          </Button>
        }
      />
    </Modal>
  );
};

export default ModalDeleteCVInterview;
